import React from 'react';
import Reference1 from 'assets/images/SATReference/reference_1.png';
import Reference2 from 'assets/images/SATReference/reference_2.png';
import Reference3 from 'assets/images/SATReference/reference_3.png';
import Reference4 from 'assets/images/SATReference/reference_4.png';
import Reference5 from 'assets/images/SATReference/reference_5.png';
import Reference6 from 'assets/images/SATReference/reference_6.png';
import Reference7 from 'assets/images/SATReference/reference_7.png';
import Reference8 from 'assets/images/SATReference/reference_8.png';
import Reference9 from 'assets/images/SATReference/reference_9.png';
import Reference10 from 'assets/images/SATReference/reference_10.png';
import Reference11 from 'assets/images/SATReference/reference_11.png';
import './index.css';

function Reference() {
    return (
        <div className='testFinderReference'>
            <div className='testFinderReference__figures'>
                <div className='testFinderReference__figureGroup'>
                    <div className='testFinderReference__figureGroupFigures'>
                        <img className='testFinderReference__figure' src={Reference1} />
                        <img className='testFinderReference__figure' src={Reference2} />
                    </div>
                </div>
                <div className='testFinderReference__figureGroup'>
                    <div className='testFinderReference__figureGroupFigures'>
                        <img className='testFinderReference__figure' src={Reference3} />
                        <img className='testFinderReference__figure' src={Reference4} />
                    </div>
                </div>
                <div className='testFinderReference__figureGroup'>
                    <div className='testFinderReference__figureGroupFigures'>
                        <img className='testFinderReference__figure' src={Reference5} />
                        <img className='testFinderReference__figure' src={Reference6} />
                    </div>
                    <p className='testFinderReference__figureText'>
                        Special Right Triangles
                    </p>
                </div>
                <div className='testFinderReference__figureGroup'>
                    <div className='testFinderReference__figureGroupFigures'>
                        <img className='testFinderReference__figure' src={Reference7} />
                        <img className='testFinderReference__figure' src={Reference8} />
                    </div>
                </div>
                <div className='testFinderReference__figureGroup'>
                    <div className='testFinderReference__figureGroupFigures'>
                        <img className='testFinderReference__figure' src={Reference9} />
                        <img className='testFinderReference__figure' src={Reference10} />
                    </div>
                </div>
                <div className='testFinderReference__figureGroup'>
                    <div className='testFinderReference__figureGroupFigures'>
                        <img className='testFinderReference__figure' src={Reference11} />
                    </div>
                </div>
            </div>
            <p className='testFinderReference__text'>
                The number of degrees of arc in a circle is 360.
            </p>
            <p className='testFinderReference__text'>
                The number of radians of arc in a circle is 2&pi;.
            </p>
            <p className='testFinderReference__text'>
                The sum of the measures in degrees of the angles of a triangle is 180.
            </p>
        </div>
    );
}

export default Reference;
